module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.1b10b8de.png";